module.exports = __webpack_public_path__ + "static/img/1044_big.4fcf7b4.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/1044_big.png
// module id = kR1L
// module chunks = 1